/** Event types offered in the notification preference and webhook subscription UIs. */
export const EVENT_TYPES = [
  'shift.assigned',
  'shift.unassigned',
  'shift.updated',
  'plan.published',
  'plan.updated',
  'availability.requested',
  'availability.approved',
  'availability.rejected',
  'shift_time_override_by_employee',
  'shift_override_reset_by_planner',
  'calendar_slot_created_for_you',
  'calendar_slot_handed_to_you',
  'calendar_slot_taken_from_you',
] as const;
